// Les deux collages proposés après un collage mis en forme.
export const PASTE_KEPT = 'kept';
export const PASTE_TEXT_ONLY = 'textOnly';

export const PASTE_CHOICE_OPTIONS = [
  { label: 'Conserver la mise en forme', value: PASTE_KEPT },
  { label: 'Conserver uniquement le texte', value: PASTE_TEXT_ONLY },
];

// Mod + Maj + V (Mod + Option + Maj + V sous Safari, d'où `code`) : coller le
// texte seul.
export const isTextOnlyPasteShortcut = (event) => (
  (event.metaKey || event.ctrlKey) && event.shiftKey && event.code === 'KeyV'
);
